<div class="collection-popup">
  <div class="collection-header">
    <label class="collection-header-title">Add Collection</label>
    <button class="header-close" (click)="closePopup()"></button>
  </div>
  <div class="collection-top" >
    <label class="collection-title-name">Collection Name</label>
    <input class="collection-input" [formControl]="collectionName" maxlength="255" placeholder="Enter a Collection Name" [ngClass]="{'invalid': isInvalid(), 'valid': isValid()}">
    @if (collectionName.invalid && (collectionName.dirty || collectionName.touched)) {
      <div class="errors">
        @if (collectionName.errors.required) {
          <div class="error-label">Name is required</div>
        }
        @if (collectionName.errors.maxlength) {
          <div class="error-label">Character limit exceeded</div>
        }
        @if (collectionName.errors.pattern) {
          <div class="error-label">Collection name can only contain letters, internal dashes and internal spaces</div>
        }
        @if (collectionName.errors['nameExists']) {
          <div class="error-label">Collection name already in use</div>
        }
      </div>
    }
    <span class="character-count">{{ collectionName.value.length }}/255 Characters</span>
  </div>
  <div style="margin-top: 35px;">
    <label class="radio-header">Select Report Type:</label>
    <label class="collection-radios" >
      <input type="radio" name="options" [(ngModel)]="selectedOptions.selectedKey" value="SINGLE_STEP" checked (change)="changeBorderColor($event)" id="singleDataTitle" > {{singleDataTitle}}
      @if (singleDataDescription | async; as description) {
        <div class="popup-description">{{description['name']}}</div>
      }
      <div class="single-data"></div>
    </label>
    <label class="collection-radios">
      <input  type="radio" name="options" [(ngModel)]="selectedOptions.selectedKey" value="SIMPLE" (change)="changeBorderColor($event)"> {{startEndDataTitle}}
      @if (startEndDataDescription | async; as description) {
        <div class="popup-description">{{description['name']}}</div>
      }
      <div class="start-end-data"></div>
    </label>
    <label class="collection-radios">
      <input type="radio" name="options" [(ngModel)]="selectedOptions.selectedKey" value="FULL" (change)="changeBorderColor($event)"> {{multiDataTitle}}
      @if (multiDataDescription | async; as description) {
        <div class="popup-description">{{description['name']}}</div>
      }
      <div class="multi-data"></div>
    </label>
    <button class="collection-save" mat-button [disabled]="collectionName.errors || nameExists === true" (click)="save()">Add Collection</button>
    <button mat-button mat-dialog-close class="collection-popup-close" (click)="closePopup()">Cancel</button>
  </div>
</div>
<saving-in-progress [showSavingInProgress]="savingInProgress" [inProgressMessage]="'Saving in progress...'"></saving-in-progress>
